const MAX_TEXT_LENGTH = 2000;

/**
 * Supprime les balises HTML/XML en utilisant le DOM natif du navigateur.
 * Fallback regex si DOMParser n'est pas disponible (environnement test).
 */
function stripHtml(str) {
  if (typeof document !== "undefined") {
    const div = document.createElement("div");
    div.innerHTML = str;
    div.querySelectorAll("script, style, noscript").forEach((el) => el.remove());
    return div.textContent ?? div.innerText ?? "";
  }
  return str.replace(/<script[\s\S]*?<\/script>/gi, "").replace(/<[^>]*>/g, "");
}

/**
 * Supprime les séquences ressemblant à du code source :
 * - balises restantes après stripHtml (entités encodées reconstruites, etc.)
 * - blocs de code style markdown (``` ... ```)
 * - injections de prompt courantes (### Instruction, [INST], etc.)
 */
function stripCodePatterns(str) {
  return str
    .replace(/```[\s\S]*?```/g, "")
    .replace(/`[^`]*`/g, "")
    .replace(/<[^>]{0,200}>/g, "")
    .replace(/\{\{[\s\S]*?\}\}/g, "")
    .replace(/\[INST\][\s\S]*?\[\/INST\]/gi, "")
    .replace(/^#+\s+.*$/gm, "")
    .replace(/javascript\s*:/gi, "")
    .replace(/data\s*:/gi, "");
}

/**
 * Normalise les espaces et tronque.
 */
function normalize(str) {
  return str.replace(/\s+/g, " ").trim().slice(0, MAX_TEXT_LENGTH);
}

export function sanitizeText(raw) {
  if (!raw || typeof raw !== "string") return "";
  return normalize(stripCodePatterns(stripHtml(raw)));
}
